import { QuotationTaskComment } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1590. 見積タスクコメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
};

const quotationTaskComments = (props: Props): Promise<QuotationTaskComment[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_comments`
  );
};

export const useQuotationTaskComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => quotationTaskComments(props),
  });
};

export const useQuotationTaskCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'sales_orders',
    props.sales_order_id,
    'quotation_tasks',
    props.task_id,
    'quotation_task_comments',
  ];
};
